import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { formatPrice, getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class RefundPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            reasonsForRefund: []
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    getReasonsForRefund = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let reasonsForRefund = [];
        if (cancellationReasons?.length) {
            reasonsForRefund = cancellationReasons.map((reason, rIdx) => {
                return {
                    ...reason,
                    key: rIdx
                }
            });
            // reasonsForRefund.push({ key: 'other', en: 'Other', se: 'Other'.translate('se') })
        }
        return reasonsForRefund;

        // let reasonsForRefund = [
        //     { en: 'Duplicate payment', se: 'Dubbel betalning' },
        //     { en: 'Cancelled by clinic', se: 'Avbokad av kliniken' },
        //     { en: 'Cancelled by patient', se: 'Avbokad av patient' },
        // ];
        // reasonsForRefund.push({ en: 'Other', se: 'Annat', key: 'other' });

        // return reasonsForRefund;
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        const status = paymentData?.currentStatus?.status?.key ?? null;
        let price = paymentData?.amount?.value ? String(paymentData.amount.value) : '0';
        if (status === 'PARTIALLY_REFUNDED') {
            // TODO: calculate the remaining amount that can be refunded
            if (paymentData?.amount?.refundAmount) {
                const remainingAmount = Number(paymentData.amount.value) - Number(paymentData.amount.refundAmount);
                price = remainingAmount ? String(remainingAmount) : '0';
            }
        }
        const messagesToPatient = paymentData?.messagesToPatient || [];
        const lastMessageToPatient = messagesToPatient?.length ? messagesToPatient[messagesToPatient.length - 1]?.message || '' : '';
        let form = {
            patientId: paymentData?.patientData?._id,
            refundAmount: price,
            maxRefundAmount: Number(price),
            currency: currency,
            reasonForRefund: -1,
            note: '',
            messageToPatient: lastMessageToPatient ?? ''
        }

        const reasonsForRefund = this.getReasonsForRefund() || [];

        this.setState({ form, currency, reasonsForRefund }, () => {
            if (this.state.form?.patientId) {
                this.findPatient();
            }
        })
    }
    checkPaymentMethods = () => {

        const groupData = this.getGroupData();

        const paymentMethods = getGroupPaymentMethods(groupData, this.props.lang);

        let setObj = { paymentMethods };

        this.setState(setObj)
    }
    findPatient = () => {
        let form = this.state.form;
        const patientId = form.patientId || null;
        const groupId = this.props.selectedGroup || null;
        if (patientId && patientId?.length === 24 && groupId) {

            fetch(API_ENDPOINT + `/api/payments/patient-data/${groupId}/${patientId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?._id) {
                    let patientData = { ...result };
                    let form = {
                        ...this.state.form,
                        patientData: patientData
                    };
                    this.setState({ form }, () => {
                        this.checkPaymentMethods();
                    });
                }
            })

        }
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                const status = payment?.currentStatus?.status?.key ?? null;
                if (!payment || ["PAID", "PARTIALLY_REFUNDED"].indexOf(status) === -1) {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();

        this.checkIfExtendedPaymentManagementEnabled();
    }
    checkIfExtendedPaymentManagementEnabled = () => {
        const groupData = this.getGroupData();
        if (groupData?._id) {
            const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
            if (!EXTENDED_PAYMENT_MANAGEMENT) {
                this.onClose();
            }
        }
    }
    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }

    selectDifferentPatient = () => {
        let form = this.state.form;
        form.patientData = null;
        form.patientId = null;
        this.setState({ form })
    }
    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }
        const refundAmount = form?.refundAmount && Number(form?.refundAmount) ? Number(form?.refundAmount) : 0;
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        const messageToPatient = form?.messageToPatient && form?.messageToPatient.trim() ? form?.messageToPatient.trim() : '';
        const reasonForRefund = this.state.reasonsForRefund?.find(r => String(r.key) === String(form?.reasonForRefund)) || null;

        const data = {
            refundAmount: refundAmount,
            reasonForRefund: reasonForRefund ? { en: reasonForRefund.en, se: reasonForRefund.se } : null,
            note: note,
            messageToPatient: messageToPatient
        };

        this.setState({ loadingRefund: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/refund/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingRefund: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};

        const refundAmount = form?.refundAmount && Number(form?.refundAmount) ? Number(form?.refundAmount) : 0;
        const maxRefundAmount = form?.maxRefundAmount && Number(form?.maxRefundAmount) ? Number(form?.maxRefundAmount) : 0;
        const currency = form?.currency || this.getCurrency() || '';
        if (refundAmount === 0) {
            errors.refundAmount = 'Refund amount is required'.translate(this.props.lang);
        }
        if (refundAmount > maxRefundAmount) {
            errors.refundAmount = `${'Refund cannot be more than'.translate(this.props.lang)} ${formatPrice(maxRefundAmount, currency)}`;
        }
        const reasonForRefund = this.state.reasonsForRefund?.find(r => String(r.key) === String(form?.reasonForRefund)) || null;
        console.log("reasonForRefund", reasonForRefund)
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        if (!reasonForRefund && this.state.reasonsForRefund?.length) errors.reasonForRefund = 'Reason for refund is required'.translate(this.props.lang);
        const isReasonForRefundOther = reasonForRefund && (reasonForRefund?.en?.trim().toLowerCase() === 'other' || reasonForRefund?.se?.trim().toLowerCase() === 'other');
        if (((!reasonForRefund && !errors.reasonForRefund) || isReasonForRefundOther) && !note) errors.note = 'Note is required'.translate(this.props.lang);


        return Object.keys(errors).length ? errors : null;
    }
    getBasicPaymentInfo = (data) => {
        const currency = data?.currency;
        const paymentData = this.state.paymentData;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;


        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN
        };

        return response;
    }

    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const currency = this.getCurrency();
        const errors = this.state.errors ?? {};

        const refundedAmount = paymentData?.amount?.refundAmount ? paymentData?.amount?.refundAmount : 0;
        const remainingAmount = paymentData?.amount?.value && refundedAmount ? Number(paymentData.amount.value) - Number(refundedAmount) : 0;
        const totalAmount = paymentData?.amount?.value ? paymentData?.amount?.value : 0;

        const vatRate = paymentData?.vat?.rate ? Number(paymentData.vat.rate) : 0;
        const basicPaymentInfo = this.getBasicPaymentInfo({ currency });
        const stripePaymentMethod = paymentData?.currentStatus?.paymentMethod?.key === 'stripe' ? true : false;

        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Refund payment'.translate(this.props.lang)}
                        <div className='modal-header-subtitle'>
                            {
                                stripePaymentMethod ?
                                    'Stripe payments are refunded automatically from Curoflow. No manual action on Stripe is needed.'.translate(this.props.lang)
                                    :
                                    'Payment will be marked as refunded but you need to do the refund in the relevant payment system'.translate(this.props.lang)
                            }
                        </div>
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg='12'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.questionaryName ? `${basicPaymentInfo.questionaryName} - ` : ''}<span>{basicPaymentInfo.price}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {'Case ID'.translate(this.props.lang)}: <span>{basicPaymentInfo.caseNumber}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.patientName} ({basicPaymentInfo.patientSSN})
                                    </div>
                                </div>
                            </Col>



                            <Col lg='12'>
                                <FormGroup className={errors.refundAmount ? 'fg-has-error' : ''} style={{ marginBottom: 0 }}>
                                    <Label>{'Refund amount'.translate(this.props.lang)}</Label>
                                    <div className='price-field-wrap'>
                                        <Input
                                            type='text'
                                            value={this.state.form?.refundAmount || '0'}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value?.length > 11) return;
                                                let form = this.state.form;
                                                form.refundAmount = Number(value);

                                                let setObj = { form };
                                                if (this.state.errors?.refundAmount) {
                                                    let errors = this.state.errors;
                                                    delete errors.refundAmount;
                                                    setObj.errors = errors;
                                                }
                                                this.setState(setObj);
                                            }}
                                        />
                                        {currency}
                                        {
                                            vatRate > 0 ?
                                                <div className='vat-rate-text'>
                                                    {`(${`${vatRate}% ${'VAT included'.translate(this.props.lang)}`})`}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>

                                </FormGroup>
                            </Col>

                            <Col lg='12'>
                                <FormGroup className={errors.refundAmount ? 'fg-has-error' : ''}>
                                    {errors.refundAmount ? <div className='error-feedback'>{errors.refundAmount}</div> : null}
                                    {
                                        refundedAmount > 0 ?
                                            <div className='field-info-text' style={{ marginTop: 5 }}>{`${'Payment has been partially refunded'.translate(this.props.lang)} (${formatPrice(remainingAmount, currency)} ${'remaining'.translate(this.props.lang)})`}</div>
                                            :
                                            <div className='field-info-text' style={{ marginTop: 5 }}>{`${'You can refund up to'.translate(this.props.lang)} ${formatPrice(totalAmount, currency)}`}</div>
                                    }
                                </FormGroup>
                            </Col>
                            {
                                this.state.reasonsForRefund?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.reasonForRefund ? 'fg-has-error' : ''}>
                                            <Label>{'Reason for refund'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='select'
                                                value={this.state.form?.reasonForRefund || -1}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (!value) value = -1;
                                                    let form = this.state.form;
                                                    form.reasonForRefund = value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.reasonForRefund || this.state.errors?.note) {
                                                        let errors = this.state.errors;
                                                        delete errors.reasonForRefund;
                                                        delete errors.note;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            >
                                                <option value={-1}>{'Select reason'.translate(this.props.lang)}</option>
                                                {
                                                    this.state.reasonsForRefund?.map((item, idx) => {
                                                        let reason = item?.[this.props.lang] ? item?.[this.props.lang] : item?.['se'];
                                                        return <option value={item?.key}>{reason}</option>
                                                    })
                                                }

                                            </Input>
                                            {errors.reasonForRefund ? <div className='error-feedback'>{errors.reasonForRefund}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }


                            <Col lg='12'>
                                <FormGroup className={errors.note ? 'fg-has-error' : ''}>
                                    <Label>{'Note'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.note || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.note = e.target.value;
                                            let setObj = { form };
                                            if (this.state.errors?.note) {
                                                let errors = this.state.errors;
                                                delete errors.note;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    />
                                    {errors.note ? <div className='error-feedback'>{errors.note}</div> : null}
                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup>
                                    <Label className='note-label-wrap'>
                                        {'Message to patient'.translate(this.props.lang)}
                                        <div className='notes-icon-wrap'>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Message to patient tooltip'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.messageToPatient || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.messageToPatient = e.target.value;
                                            this.setState({ form });
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingRefund}
                        >
                            {'Refund'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>




            </>
        );
    }
}


export default RefundPayment;